<script lang="ts">
	import { page } from '$app/stores';

	$: site = $page.data.site;
</script>

<footer class="site-footer">
	<div class="container footer-inner">
		<p>© {new Date().getFullYear()} {site.name}. All rights reserved.</p>
		<ul class="footer-links">
			<li>
				<a href="/#archive">Notes</a>
			</li>
			<li>
				<a href={site.urls.home}>Home</a>
			</li>
			<li>
				<a href="{site.urls.home}/verify">Verify</a>
			</li>
			<li>
				<a href={site.urls.github} rel="noopener noreferrer">GitHub</a>
			</li>
			<li>
				<a href={site.urls.x} rel="noopener noreferrer">X</a>
			</li>
			<li>
				<a
					href="{site.urls.home}{site.pgp.path}"
					title="OpenPGP public key ({site.pgp.fingerprint})">PGP</a
				>
			</li>
		</ul>
	</div>
</footer>
